import { Empresa } from './../../company-view/company-view-detail/models/Empresa/Empresa';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';
import { StaffImportService } from '../services/staff-import.service';
import { CompletaStaffImportConfirmationModalComponent } from './popups/completa-staff-import-confirmation-modal/completa-staff-import-confirmation-modal.component';
import { ImportarEmpresaModalComponent } from './popups/importar-empresa-modal/importar-empresa-modal.component';

@Component({
    selector: 'app-staff-import-view',
    templateUrl: './staff-import-view.component.html',
    styleUrls: ['./staff-import-view.component.scss'],
    standalone: false
})
export class StaffImportViewComponent implements OnInit {

  @ViewChild('appParameterPanel') appParameterPanel: any;
  selectedEmpresaId:number;
  selectedEmpresa:string;
  constructor(public dialog: MatDialog,  
    private sharedService: SharedService,    
    public staffImportService: StaffImportService,
    public pageLoaderService: PageLoaderService,
    public fileExportService: FileExportService) { }

  ngOnInit(): void {
  }

  openImportarEmpresa(){

    if(!this.selectedEmpresaId){ this.selectedEmpresaId=1;}
    if(!this.selectedEmpresa){ this.selectedEmpresa="IT";}

    let selectedEmpresaObj={
      empresaId:this.selectedEmpresaId,
      empresa:this.selectedEmpresa
    }

    const modalRef = this.dialog.open(ImportarEmpresaModalComponent, { data: selectedEmpresaObj});
    modalRef.afterClosed().subscribe(res => {  
    });
  }

  selectTreeView(empresaObj: any) {
    let empresa = empresaObj.empresa;
    let empresaid=empresaObj.empresaId
    if(empresaid==0)
    {
      this.selectedEmpresaId=empresaid;
      this.selectedEmpresa="IT"
      empresaid=1;
      empresa="IT"
    }
    if (empresaid > 0) {
      this.selectedEmpresaId=empresaid;
      this.selectedEmpresa=empresa;
    }
  }

  staffExcelImport(){
    var model = this.appParameterPanel.getParamterControls();
    //model.empresaId = parseInt(localStorage.getItem('Empresa'));
    if(this.selectedEmpresaId)
    {
      model.empresaId=this.selectedEmpresaId;
    }else
    {
      model.empresaId=1;
    }
   
    if(!model.excelfile){
      this.sharedService.ShowSnackBar('Adjunta un fichero Excel');
      return;
    }
    const minimumYear = new Date().getFullYear() - 5
    if(!model.anyo || model.anyo == 0 || minimumYear>model.anyo){
      this.appParameterPanel.setInvalidFormCOntrol("anyo");
      return;
    }    
    if(!model.primeraFila || model.primeraFila == 0 || model.primeraFila < 1 ){
      this.appParameterPanel.setInvalidFormCOntrol("primeraFila");
      return;
    }
    if(!model.columnaClave || model.columnaClave == 0 || model.columnaClave < 1){
      this.appParameterPanel.setInvalidFormCOntrol("columnaClave");
      return;
    }
    if(!model.hojas || model.hojas == 0 || model.hojas < 1){
      this.appParameterPanel.setInvalidFormCOntrol("hojas");
      return;
    }
    if(model.camposImportacion && model.tipoImportacion == 1){
      if(model.camposImportacion.filter(x=>x.columnName.includes("Atributo")).length > 1){
        this.sharedService.ShowSnackBar('Hay más de un atributo introducido');
        return;
      }
      if(model.camposImportacion.filter(x=>x.columnName.includes("Plantilla")).length == 0){
        this.sharedService.ShowSnackBar('Falta el campo plantilla');
        return;
      }
    }
    if(model.camposImportacion && model.tipoImportacion == 3){
      if(model.camposImportacion.filter(x=>x.columnName.includes("Plantilla")).length != 0){
        this.sharedService.ShowSnackBar('No se puede especificar la plantilla si se está totalizando');
        return;
      }   
    }
    if(model.tipoImportacion == 2){
      const modalRef = this.dialog.open(CompletaStaffImportConfirmationModalComponent, { data: "", width: '500px'});
      modalRef.afterClosed().subscribe(res => {  
        if(res && res != 3){
          model.completeStatus = res;
          this.staffExcelImportCallMethod(model);
        } 
      });
    }else{
      this.staffExcelImportCallMethod(model);
    }   
  }

  staffExcelImportCallMethod(model: any){
    this.pageLoaderService.ShowPageLoader();
    this.staffImportService.StaffExcelImport(model)
    .subscribe(res => {  
      if (res.code === 0) {
        if(model.tipoImportacion == 1){
          this.sharedService.ShowSnackBar('Se han actualizado '+res.result.rowsWithoutError+' plantillas');
        }
        if(model.tipoImportacion == 2){
          this.sharedService.ShowSnackBar('Se han cargado '+res.result.rowsWithoutError+' registros de plantilla');
        }
        if(res.result && res.result.errorDocument && res.result.errorDocument.file !== null && res.result.errorDocument.file !== undefined){
          this.sharedService.ShowSnackBar('Se han producido '+res.result.rowsWithError+' errores mostrados en la hoja Excel.');
          this.fileExportService.DownloadFile(res.result.errorDocument.file, res.result.errorDocument.fileName);
        }else if(model.tipoImportacion == 3){
          this.sharedService.ShowSnackBar('Plantillas importadas');
        }if(model.tipoImportacion == 4){
          this.sharedService.ShowSnackBar('Se han cargado '+res.result.rowsWithoutError+' registros de CuentaProyecto');
        }
      }else{
        this.sharedService.ShowSnackBar('error');
        console.error("Staff Import Error :" + res.message);
      }
      this.pageLoaderService.HidePageLoader();
    }, err => {
      this.sharedService.ShowSnackBar('error');
      console.error(err);
      this.pageLoaderService.HidePageLoader();
    });
  }
}
